"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Attachment = function Attachment(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon icon-no-fill ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 23.25,9.9L12.273,20.878c-2.636,2.636-6.91,2.636-9.546,0s-2.636-6.91,0-9.546l9.016-9.015 c1.727-1.788,4.575-1.837,6.363-0.111c1.788,1.727,1.837,4.575,0.111,6.363c-0.036,0.037-0.073,0.074-0.111,0.111L9.091,17.7 c-0.894,0.863-2.318,0.839-3.182-0.055c-0.842-0.872-0.842-2.254,0-3.126L14.925,5.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    fill: "none",
    stroke: fill
  })));
};
Attachment.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Attachment.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Attachment;